import React, { ChangeEvent } from 'react';
import { Radio } from '@mediahuis/chameleon-react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

export type FormikRadioButtonOption = {
  value: string;
  label: string | string[];
  checked: boolean;
};
export type FormikRadioButtonPickerProps<T> = {
  name: Extract<keyof T, string>;
  label?: string;
  options?: FormikRadioButtonOption[];
  formikProps: FormikProps<T>;
};

// Chameleon Radio wrapped with Formik helpers
export const FormikRadioButtonPicker = <T,>(
  formikRadioButtonPickerProps: FormikRadioButtonPickerProps<T>
) => {
  const { t } = useTranslation();
  const { touched, errors, setFieldValue } = formikRadioButtonPickerProps.formikProps;
  const { options } = formikRadioButtonPickerProps;

  return (
    <>
      {options?.map((option: FormikRadioButtonOption) => (
        <Radio
          id={`gender-${option.value}`}
          name={formikRadioButtonPickerProps.name}
          value={option.value}
          checked={option.checked}
          key={`key-${option.value}`}
          data-cy={`gender${option.value}`}
          label={t(option.label)}
          error={
            errors[formikRadioButtonPickerProps.name] && touched[formikRadioButtonPickerProps.name]
          }
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setFieldValue(
              formikRadioButtonPickerProps.name,
              event.target.value,
              !!errors[formikRadioButtonPickerProps.name]
            );
            formikRadioButtonPickerProps.formikProps.setFieldTouched(
              formikRadioButtonPickerProps.name
            );
          }}
        />
      ))}
    </>
  );
};
